






























































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { CspInquiry, Inquiry, Hd, yun } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import SAddress from './components/SAddress.vue'
import FAddress from './components/FAddress.vue'
import AddressSelect from './components/AddressSelect.vue';
import { upload } from '@/common/util/ossUploadService';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
        AddressSelect,
        FAddress,
        SAddress,
    },
})
export default class ReceiptManage extends Vue {
    public receiptStatusList = [];
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public inquiryStatusType = enums.inquiryStatusType;
    public labelPosition: string = 'right';
    public hdStauts = enums.receiptStatusEnum;
    public waybillStatus = enums.receiptWayBillStatusType;
    public expandType: boolean = false;
    public dialogVisible: boolean = false;
    public dialogVisible1:boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    public dialogConfig: any = {
        title: '',
        show: false,
    };
    selectList: any = [];
    async querySearchcys(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    // selectCys(data) {
    //     this.searchValue.carrierId = data.id;
    // }
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.creationStartTime = value[0];
            this.searchValue.creationEndTime = value[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }
    timeList2 = [];
    public datetimerange2(value) {
        if (value) {
            this.searchValue.realDeliveryStartTime = value[0];
            this.searchValue.realDeliveryEndTime = value[1];
        } else {
            this.searchValue.realDeliveryStartTime = null;
            this.searchValue.realDeliveryEndTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        carrierOrderCode: '',
        orderCode: '',
        subOrderNo:'',
        shipOrderNo:'',
        originShipOrderNo:'',
        deliveryOrderNo:'',
        // shipperName:'',
        // carrierName: '',
        customerBaseId:'',
        carrierId:'',
        consignee: '',
        originAddress: '',
        arrivalAddress: '',
        carCode: '',
        carrierOrderStatus: '',
        receiptStatus: '',
        creationStartTime: '',
        creationEndTime: '',
        realDeliveryStartTime: '',
        realDeliveryEndTime: '',
        // startTime: '',
        // endTime: '',
        // deliveryAddress: '',
        // code: '',
        // inquiryWay: '',
        // statusListStr: '',
        // winner: '',
        orderBy: '',
    };
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        address1:HTMLFormElement;
        address2:HTMLFormElement;
        cascader:HTMLFormElement;
    };

    public handleClose() {
        this.dialogVisible = false;
    }
     public handleClose1() {
        this.dialogVisible1 = false;
    }
    // public yl(row){
    //     this.dialogVisible = true;
    //     Hd.viewHd(row.id).then((res)=>{
    //         console.log('view->',res);
    //     })
    // }
    public ylPics: any = [];
    public yl(row) {
        console.log('yl', row);
        this.ylPics = [];
        Hd.viewHd(row.id)
            .then((res) => {
                this.ylPics = res.map((v) => {
                    return { name: v.attachmentName, url: v.attachmentUrl };
                });
                console.log('yl-->', res, this.ylPics);
            })
            .catch(() => {});

        this.dialogVisible = true;
    }
    public selectReset:boolean = false;
    public selectReset2:boolean = false;
    public isChangeMileage:boolean = true;
    public hdq3: boolean = false;
    public customerBaseIds = [];
    public carrierIds = [];
    public created() {
        this.selectReset = true;
        this.selectReset2 = true;
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.hdq3 = webMenus.includes('hdq3');
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        // this.getcustomerBaseId();
        // this.getcarrierId();
        if (this.$route.query.type === 'dashboard') {
            this.searchValue = {
                // carrierOrderCode: '',
                // orderCode: '',
                // carrierName: '',
                // consignee: '',
                // originAddress: '',
                // arrivalAddress: '',
                // carCode: '',
                // carrierOrderStatus: '',
                // receiptStatus: '',
                // creationStartTime: '',
                // creationEndTime: '',
                // orderBy: '',
                  carrierOrderCode: '',
                    orderCode: '',
                    subOrderNo:'',
                    shipOrderNo:'',
                    originShipOrderNo:'',
                    deliveryOrderNo:'',
                    // shipperName:'',
                    // carrierName: '',
                    customerBaseId:'',
                    carrierId:'',
                    consignee: '',
                    originAddress: '',
                    arrivalAddress: '',
                    carCode: '',
                    carrierOrderStatus: '',
                    receiptStatus: '',
                    creationStartTime: '',
                    creationEndTime: '',
                    realDeliveryStartTime: '',
                    realDeliveryEndTime: '',
                    // startTime: '',
                    // endTime: '',
                    // deliveryAddress: '',
                    // code: '',
                    // inquiryWay: '',
                    // statusListStr: '',
                    // winner: '',
                    orderBy: '',
            };
            this.statusArr = [];
            this.timeList = [];
            this.timeList2 = [];
            this.receiptStatusList = ['1', '2'];
            this.searchValue.statusListStr = '1,2';
            this.searchFunc();
            this.isActive = true;
        } else {
            if (sessionStorage.getItem('qyhd_searchValue')) {
                this.searchValue = JSON.parse(sessionStorage.getItem('qyhd_searchValue'));
                this.timeList = [this.searchValue.creationStartTime, this.searchValue.creationEndTime];
                this.timeList2 = [this.searchValue.realDeliveryStartTime, this.searchValue.realDeliveryEndTime];
                if (this.searchValue.carrierOrderStatus) {
                    this.statusArr = this.searchValue.carrierOrderStatus.split(',');
                }
                this.searchPagin = sessionStorage.getItem('qyhd_page') ? JSON.parse(sessionStorage.getItem('qyhd_page')) : this.searchPagin;
                this.getInquiryList();
            } else {
                this.searchPagin = sessionStorage.getItem('qyhd_page') ? JSON.parse(sessionStorage.getItem('qyhd_page')) : this.searchPagin;
                this.getInquiryList();
            }
        }
    }
    // public async getcustomerBaseId(){
    //     let result = await Hd.GetDropDownList();
    //     result.forEach((item)=>{
    //         this.customerBaseIds.push({
    //             label:item.customerBaseName,
    //             value: item.customerBaseName,
    //         })
    //     })
    // }
    //  public async getcarrierId(){
    //     let result = await Hd.GetCarrierList();
    //     result.data.forEach((item)=>{
    //         this.carrierIds.push({
    //             label:item.name,
    //             value: item.name,
    //         })
    //     })

    // }
    // // 发货方发生改变
    // public customerBaseid = '';
    // public async customerBaseIdChange(val){
    //      let result = await Hd.GetDropDownList();
    //      this.searchValue.customerBaseId = result.filter((item)=>item.customerBaseName===val)[0].id;
    //      console.log(this.searchValue.customerBaseId,'this.searchValue.customerBaseId');
    // }
    //  // 车队发生改变
    // public carrierid = '';
    // public async carrierIdChange(val){
    //      let result = await Hd.GetCarrierList();
    //      this.searchValue.carrierId = result.data.filter((item)=>item.name===val)[0].id;
    //      console.log(this.searchValue.carrierId,'this.searchValue.carrierId');
    // }
    public restaurants = [];
    async querySearchAsyncSh(queryString, cb) {
        let res = await Hd.GetDropDownList({
            name: this.searchValue.customerBaseName,
        });
        this.restaurants = [];
        if (res) {
            res.forEach((item) => {
                this.restaurants.push({
                    id:item.id,
                    value: item.customerBaseName,
                    name: item.customerBaseContactName,
                });
            });
            cb(this.restaurants);
        }
    }
    async handleSelectSh(item, index) {     
        this.searchValue.customerBaseId = item.id
    }
    public restaurants2 = [];
    async querySearchAsyncSh2(queryString, cb) {
        let res = await Hd.GetCarrierList({
            name: this.searchValue.carrierName,
            count: 30,
        });
        this.restaurants2 = [];
        if (res.data) {
            res.data.forEach((item) => {
                this.restaurants2.push({
                    id:item.id,
                    value: item.name,
                    name: item.contactName,
                });
            });
            cb(this.restaurants2);
        }
    }
    async handleSelectSh2(item, index) {     
        this.searchValue.carrierId = item.id
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            // case 'clientOrderCode':
            //     {
            //         this.searchValue.orderBy = '1';
            //     }
            //     break;
            case 'consignee':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            // case 'carriageWay':
            //     {
            //         this.searchValue.orderBy = '3';
            //     }
            //     break;
            case 'realDeliveryTime':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'realArrivalTime':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'carLengthEnumStr':
                {
                    this.searchValue.orderBy = '4';
                }
                break;
            case 'carrierOrderStatusStr1':
                {
                    this.searchValue.orderBy = '5';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = '6';
                }
                break;
             case 'originAddress':
                {
                    this.searchValue.orderBy = '7';
                }
                break;
             case 'arrivalAddress':
                {
                    this.searchValue.orderBy = '8';
                }
                break;
        }
        this.getInquiryList();
    }
    public toOrder(data) {}
    public srow: any;
    public upics = [];
    public cid = '';
    public toEdit(row) {
        // this.$router.push({
        //     path: '/AddInquiry',
        //     query: {
        //         id: data.id,
        //         type: 'edit',
        //     },
        // });
        //to qianshou
        // this.srow = data;
        // this.dialogConfig = {
        //     title: '签收回单',
        //     show: true,
        // };
        // this.$confirm('确认签收回单?', '回单签收', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Hd.signHd(data.id).then((res) => {
        //             this.$message.success('签收成功');
        //             this.getInquiryList();
        //         });
        //     })
        //     .catch(() => {});
        // console.log('签收');
        console.log('row', row);
        this.upics = [];
        Hd.viewHd(row.id)
            .then((res) => {
                this.upics = res.map((v) => {
                    return { name: v.attachmentName, url: v.attachmentUrl };
                });
                console.log('yl-->', res, this.upics);
            })
            .catch(() => {});
        this.cid = row.id;
        this.dialogVisible1 = true;
    }
    public toUpload(){
         let attachements = this.upics.map((v) => {
            return { attachmentName: v.name, attachmentPath: v.url };
        });
        Hd.signHd({ carrierOrderId: this.cid, attachements: attachements })
            .then((res) => {
                console.log('upload-->', res);
                this.$message.warning('回单上传成功!');
                this.getInquiryList();
                this.dialogVisible1 = false;
            })
            .catch(() => {});
    }
    public async handleUpload(param, file, fileList) {
        console.log('toupload-->', param);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url);
            this.upics.push({ name: param.file.name, url: url });
            //this.pics.push(file)
            //this.$emit('setImage', param.file.name, url, param.file.uid);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public onexceed() {
        this.$message.warning('最多上传20张!');
    }
    public handleRemove(file, fileList) {
        // this.pics=this.pics.filter(v=>{
        //     return v.uid!=file.uid;
        // })
        if (this.upics.includes(file)) {
            this.upics.splice(this.upics.indexOf(file), 1);
        }
        console.log(file, fileList);
        //this.$emit('deleteImage', file.name, file.uid, file.url);
    }
     public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    dialogImageUrl = '';
    dialogImage: any = false;
    public handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImage = true;
    }
    // async confirmOk() {
    //     Hd.signHd(this.srow.id).then((res) => {
    //         this.$message.success('签收成功');
    //         this.getInquiryList();
    //     });
    //     this.dialogConfig = {
    //         show: false,
    //     };
    // }
    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        if(this.statusArr.length===0){
            this.searchValue.carrierOrderStatus = '1,2,3'
        }
        else {
            this.searchValue.carrierOrderStatus = this.statusArr.join();
        }      
        let data = await Hd.Export(this.searchValue);
    }

    public getInquiryList() {
        this.loading = true;
         if(this.statusArr.length===0){
            this.searchValue.carrierOrderStatus = '1,2,3'
        }
        else {
            this.searchValue.carrierOrderStatus = this.statusArr.join();
        }
        this.searchValue.receiptStatus = this.receiptStatusList.join();
        Hd.getList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                /**无数据返回上一页 */
                if (this.searchPagin.currentPage > 1) {
                    if (this.tableData.length == 0) {
                        this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                        this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                    }
                }
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        // if(this.statusArr.length===0){
        //     this.searchValue.carrierOrderStatus = '1,2,3'
        // }
        // else {
        //     this.searchValue.carrierOrderStatus = this.statusArr.join();
        // }
        this.getInquiryList();
        sessionStorage.setItem('qyhd_searchValue', JSON.stringify(this.searchValue));
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('qyhd_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('qyhd_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/InquiryDetail',
            query: {
                type: 'view',
                id: item.id,
            },
        });
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    // handleSelectionChange(rows) {
    //     this.selectionRow = rows; //保存已选择行
    //     if (rows.length) {
    //         this.isDisabled = false;
    //     } else {
    //         this.isDisabled = true;
    //     }
    // }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type, index) {
        //let bd = row.orderList.length > 1 ? true : false;
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    // id: row.id,
                    // name: 'detail',
                    // orderCnt:row.orderList.length,
                    // orderId:row.orderList[0].id
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    orderId: row.id,
                    tab: 'second',
                    type:'receipt'
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.orderList[index].id,
                    name: 'detail',
                    //orderCnt:row.orderList.length,
                    //orderId:row.orderList[0].id
                    from: 'receiptManager',
                },
            });
        } else if (type == 3) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    orderId: row.orderList[0].id,
                },
            });
        }
    }
    // copAdd() {
    //     if (this.selectionRow.length != 0) {
    //         this.$router.push({
    //             path: '/AddInquiry',
    //             query: {
    //                 type: 'copy',
    //                 id: this.selectionRow[0].id,
    //             },
    //         });
    //     } else {
    //         this.$router.push({
    //             path: '/AddInquiry',
    //             query: {},
    //         });
    //     }
    // }

    public handleDelete(data) {
        this.$confirm('确认删除该询价单?', '询价单删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.DelInquiry(data).then(() => {
                    this.$message.success('询价单删除成功');
                    this.getInquiryList();
                });
            })
            .catch(() => {});
    }
    public handleFinal(data) {
        this.$confirm('确认终结该询价单?', '询价单终结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.EndInquiry(data).then(() => {
                    this.$message.success('询价单终结成功');
                    this.getInquiryList();
                });
            })
            .catch(() => {});
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    // public colData =
    //     JSON.parse(localStorage.getItem('qyhd')) && JSON.parse(localStorage.getItem('qyhd')).length == 15
    //         ? JSON.parse(localStorage.getItem('qyhd'))
    //         : [
    //               { title: '回单状态', isShow: true, disabled: false },
    //               { title: '运单编号', isShow: true, disabled: false },
    //               { title: '计划编号', isShow: true, disabled: false },
    //               { title: '承运商', isShow: true, disabled: false },
    //               { title: '发货地址', isShow: true, disabled: false },
    //               { title: '收货地址', isShow: true, disabled: false },
    //               { title: '发货方', isShow: true, disabled: false },
    //               { title: '发货时间', isShow: true, disabled: false },
    //               { title: '卸货时间', isShow: true, disabled: false },
    //               { title: '车牌号', isShow: true, disabled: false },
    //               { title: '车长', isShow: true, disabled: false },
    //               { title: '司机', isShow: true, disabled: false },
    //               { title: '运单状态', isShow: true, disabled: false },
    //               { title: '回单照片', isShow: true, disabled: false },
    //               { title: '下单时间', isShow: true, disabled: false },
    //           ];
     public colData =
        JSON.parse(localStorage.getItem('qyhd')) && JSON.parse(localStorage.getItem('qyhd')).length ==20
            ? JSON.parse(localStorage.getItem('qyhd'))
            : [
                  { title: '回单状态', isShow: true, disabled: false },
                  { title: '运单编号', isShow: true, disabled: false },
                  { title: '计划编号', isShow: true, disabled: false },
                  { title: '子单号', isShow: true, disabled: false },
                  { title: '装运单号', isShow: true, disabled: false },
                  { title: '原装运单号', isShow: true, disabled: false },
                  { title: '交货单号', isShow: true, disabled: false },
                  { title: '客户/基地名称', isShow: true, disabled: false },
                  { title: '车队名称', isShow: true, disabled: false },
                  { title: '发货地址', isShow: true, disabled: false },
                  { title: '收货地址', isShow: true, disabled: false },
                  { title: '收货方', isShow: true, disabled: false },
                  { title: '发货时间', isShow: true, disabled: false },
                  { title: '送达时间', isShow: true, disabled: false },
                  { title: '车牌号', isShow: true, disabled: false },
                  { title: '车长', isShow: true, disabled: false },
                  { title: '司机', isShow: true, disabled: false },
                  { title: '运单状态', isShow: true, disabled: false },
                  { title: '回单照片', isShow: true, disabled: false },
                  { title: '下单时间', isShow: true, disabled: false },
              ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('qyhd', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
        carrierOrderCode: '',
        orderCode: '',
        subOrderNo:'',
        shipOrderNo:'',
        originShipOrderNo:'',
        deliveryOrderNo:'',
        // shipperName:'',
        // carrierName: '',
        customerBaseId:'',
        carrierId:'',
        consignee: '',
        originAddress: '',
        arrivalAddress: '',
        carCode: '',
        carrierOrderStatus: '',
        receiptStatus: '',
        creationStartTime: '',
        creationEndTime: '',
        realDeliveryStartTime: '',
        realDeliveryEndTime: '',
        orderBy: '',
        };
        // this.customerBaseid = '';
        // this.carrierid = '';
        this.receiptStatusList = [];
        this.statusArr = [];
        this.timeList = [];
        this.timeList2 = [];
        this.searchFunc();
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待派车':
                return 'c_yellow';
            case '待发货':
                return 'c_yellow';
            case '在途中':
                return 'c_blue';
            case '已送达':
                return 'c_green';
            case '已终结':
                return 'c_red';

            default:
                break;
        }
    }
    flexColumnWidth(str, tableData, flag = 'max') {
        console.log('tableData', tableData);
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 150) {
            // 设置最小宽度
            flexWidth = 150;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    flexColumnWidthArray(str, tableData, flag = 'max') {
        console.log('tableData', tableData);
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            let indexy = 0;
            for (let i = 0; i < tableData.length; i++) {
                for (let j = 0; j < tableData[i].orderList.length; j++) {
                    if (tableData[i].orderList[j] === null) {
                        continue;
                    }
                    const now_temp = tableData[i].orderList[j][str] + '';
                    const max_temp = tableData[index].orderList[indexy][str] + '';
                    console.log('valllll->', tableData[i].orderList[j], i, j, tableData[i].orderList[j][str], index, indexy);
                    if (now_temp.length > max_temp.length) {
                        index = i;
                        indexy = j;
                    }
                }
                // if (tableData[i][str] === null) {
                //     return;
                // }
                // const now_temp = tableData[i][str] + '';
                // const max_temp = tableData[index][str] + '';
                // if (now_temp.length > max_temp.length) {
                //     index = i;
                // }
            }
            console.log('yunhuanjies', index, indexy);
            columnContent = tableData[index].orderList[indexy][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 150) {
            // 设置最小宽度
            flexWidth = 150;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
     getShowData(data){
        let list = data.split(",");
        return list;
    }
}
